import _regeneratorRuntime from "D:\\projects\\suseval\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\projects\\suseval\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import isMeteorUser from "./meteor/isMeteorUser";
var routerInstance = void 0;
export default
/*#__PURE__*/
(function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(_ref) {
    var router;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            router = _ref.router;
            // something to do
            routerInstance = router;
            routerInstance.beforeResolve(
            /*#__PURE__*/
            function () {
              var _ref3 = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee(to, from, next) {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        /* console.log(`Before resolve:`)
                        console.log(`Route to`, to)
                        console.log(`Route from`, from) */
                        if (to.path.indexOf('assesment') >= 1) {
                          isMeteorUser().then(function (response) {
                            // if true, continue, else redirect to Login page
                            // response ? next() : next({ name: 'welcome' })
                            response ? next() : next({
                              name: 'Projects'
                            });
                          });
                          /* try {
                              await askForCameraPermission()
                          } catch (error) {
                              if (error instanceof NotAllowedError) {
                                  // ... handle the error and then cancel the navigation
                                  return false
                              } else {
                                  // unexpected error, cancel the navigation and pass the error to the global handler
                                  throw error
                              }
                          } */
                        } else {
                          // console.log('true')
                          next();
                        }

                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x2, _x3, _x4) {
                return _ref3.apply(this, arguments);
              };
            }());

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();
export { routerInstance };
/* import { boot } from 'quasar/wrappers'

export default boot(({ router, store }) => {
    router.beforeEach((to, from, next) => {
        // Now you need to add your authentication logic here, like calling an API endpoint

        console.log('store', store) // undefined

        next()
    })
}) */